import wrapper from 'wrapper';

function setupOffset({ id, offsetVal, stepClass }) {
    const el = document.createElement('div');
    el.setAttribute('id', getOffsetId(id));
    el.setAttribute('class', 'scrolly-debug--offset');

    const text = document.createElement('p');
    text.setAttribute('class', 'scrolly-debug--text');
    text.innerText = `".${stepClass}" trigger: ${offsetVal}`;
    el.appendChild(text);
    wrapper.select('.bbc-news-vj-wrapper').appendChild(el);
}

function updateOffset({ id, offsetMargin }) {
    const idVal = getOffsetId(id);
    const el = wrapper.select(`#${idVal}`);
    el.style.top = `${offsetMargin}px`;
}

function getOffsetId(id) {
    return `scrolly__debug-offset--${id}`;
}

export { setupOffset, updateOffset };
